import classNames from 'classnames';
import {Dropdown} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import ChatEmptyProfileImage from '../../../assets/image/shared/chat_empty_profile_image.svg';
import TimeDifferenceConvertor from '../../../utilities/helper/timeConvertor';
import styles from './message.module.scss';
import React from 'react';
import useRemoveMessage from '../hooks/useDeleteMessage';

type CustomToggleProps = {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const CustomToggle = React.forwardRef(
  (props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <div>
      <i
        className="icon-setting-chats color-gray-1 pt-1"
        ref={ref}
        onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          e.stopPropagation();
          props?.onClick(e);
        }}
      >
        {props.children}
      </i>
    </div>
  ),
);

// const root = document.querySelector('body') as HTMLElement;

// type ModalProps = {
//   children: ReactNode;
// };

// function BackDrop({children}: ModalProps) {
//   // create div element only once using ref
//   const elRef = useRef<HTMLDivElement | null>(null);
//   if (!elRef.current) elRef.current = document.createElement('div');

//   useEffect(() => {
//     const el = elRef.current!; // non-null assertion because it will never be null
//     root.appendChild(el);
//     return () => {
//       root.removeChild(el);
//     };
//   }, []);

//   return createPortal(children, elRef.current);
// }

type TMessageProps = {
  message: IMessage;
  refetch: () => void;
};
const Message = ({message, refetch}: TMessageProps) => {
  const navigate = useNavigate();
  const {mutate} = useRemoveMessage(refetch);
  const deleteMessage = () => {
    const payload: IRemoveMessagePayload = {
      guid: message.guid,
    };
    mutate(payload);
  };

  return (
    <>
      <div
        className={classNames(
          styles['message'],
          'd-flex w-100 justify-content-between align-items-center border-bottom py-1',
        )}
      >
        <div
          className="d-flex align-items-center"
          onClick={() =>
            navigate('/message/room', {
              state: {
                id: message.guid,
                title: message.contact_detail.name,
              },
            })
          }
        >
          <img src={ChatEmptyProfileImage} alt="" />
          {!message.is_seen && <div className={styles['message__badge']}></div>}

          <div
            className={classNames(
              styles['message__text'],
              'd-flex flex-column flex-grow-1 me-3 text-truncate w-25',
            )}
          >
            <span className="m-0 color-gray-1">
              {message.contact_detail.name}
            </span>

            <small
              className={classNames(
                message.is_seen ? 'color-gray-3' : 'color-primary',
                'd-inline-block text-truncate',
              )}
            >
              {message.last_message_text}
            </small>
          </div>
        </div>
        <div
          className={classNames(
            styles['message__details'],
            'd-flex flex-column align-items-end h-100 pt-2',
          )}
        >
          <Dropdown>
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu title="">
              <Dropdown.Item>
                <div
                  className="text-end w-100 d-flex align-items-center"
                  onClick={deleteMessage}
                >
                  <i className="icon-delete  color-primary ps-1"></i>
                  حذف
                </div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="pt- ps-2">
            <small className="color-gray-9 font-size-5">
              {TimeDifferenceConvertor(message?.last_message_date)}
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
